module.exports = __webpack_public_path__ + "static/img/043_TO8_1545_og.ad8b09a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/043_TO8_1545_og.jpg
// module id = zfpI
// module chunks = 0